export const ISSUE_ATTRIBUTES_DATA_TYPES = {
  TEXT: 'text',
  SINGLE_LIST: 'list',
  PARAGRAPH: 'paragraph',
  NUMERIC: 'numeric'
};

export const ISSUE_ATTRIBUTES_TYPES_DROPDOWN_ORDER = [
  ISSUE_ATTRIBUTES_DATA_TYPES.TEXT,
  ISSUE_ATTRIBUTES_DATA_TYPES.SINGLE_LIST,
  ISSUE_ATTRIBUTES_DATA_TYPES.PARAGRAPH,
  ISSUE_ATTRIBUTES_DATA_TYPES.NUMERIC
];

export const ISSUE_ATTRIBUTES_PERMITTED_ACTIONS = {
  EDIT: 'edit',
  DELETE: 'delete',
  CHANGE_ORDER: 'change_order'
};

export const ISSUE_ATTRIBUTE_MAPPING_FIELD_NAMES = {
  IS_REQUIRED: 'isRequired'
};

export const ISSUE_ATTRIBUTE_MAX_TITLE_LENGTH = 100;
export const ISSUE_ATTRIBUTE_MAX_DESCRIPTION_LENGTH = 500;
export const ISSUE_ATTRIBUTE_MAX_LIST_ITEM_TEXT_LENGTH = 100;
export const ISSUE_ATTRIBUTE_MAX_LIST_ITEM_ITEMS_LENGTH = 100;

export const ISSUE_ATTRIBUTES_TYPE_LIMITATIONS = {
  [ISSUE_ATTRIBUTES_DATA_TYPES.TEXT]: 100,
  [ISSUE_ATTRIBUTES_DATA_TYPES.SINGLE_LIST]: 100,
  [ISSUE_ATTRIBUTES_DATA_TYPES.NUMERIC]: 60,
  [ISSUE_ATTRIBUTES_DATA_TYPES.PARAGRAPH]: 100
};

export const ISSUE_ATTRIBUTES_MAPPED_ITEM_TYPES = {
  CONTAINER: 'container',
  SUBTYPE: 'issueSubtype',
  TYPE: 'issueType'
};

export const ISSUE_ATTRIBUTES_DELETE_CHECKBOXES = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  PROJECT: 'PROJECT'
};
